(function () {
const toggle = document.getElementById('search-toggle') || document.getElementById('search-toggle-mobile');
  const drawer = document.getElementById('search-drawer');
  const input  = document.getElementById('search-input');
  const close  = document.getElementById('search-close');
  const list   = document.getElementById('search-results-list');

  if (!toggle || !drawer || !input || !close || !list) return;

  let debounceTimer = null;
  let activeIndex   = -1;
  let results       = [];

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    input.setAttribute('aria-expanded', 'true');
    input.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-expanded', 'false');
    input.value = '';
    list.innerHTML = '';
    results = [];
    activeIndex = -1;
  }

  toggle.addEventListener('click', function () {
    drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
  });

  close.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      toggle.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (!drawer.contains(e.target) && e.target !== toggle) {
      if (drawer.classList.contains('is-open')) closeDrawer();
    }
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderResults(data) {
    list.innerHTML = '';
    results = [];
    activeIndex = -1;

    const products   = (data.resources && data.resources.results && data.resources.results.products)   || [];
    const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    const pages      = (data.resources && data.resources.results && data.resources.results.pages)      || [];

    const all = [
      ...products.map(p => ({ type: 'product', item: p })),
      ...collections.map(c => ({ type: 'collection', item: c })),
      ...pages.map(p => ({ type: 'page', item: p }))
    ];

    if (all.length === 0) {
      list.innerHTML = '<li class="search-results__empty">No results found.</li>';
      return;
    }

    all.forEach(function (entry, i) {
      const { type, item } = entry;
      results.push(item.url);

      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('tabindex', '-1');
      li.dataset.index = i;

      let imageHtml = '';
      if (type === 'product' && item.featured_image && item.featured_image.url) {
        imageHtml = `<img class="search-result__image" src="${item.featured_image.url}&width=72" alt="${item.title}" loading="lazy">`;
      } else if (type === 'product') {
        imageHtml = `<div class="search-result__image--placeholder"></div>`;
      }

      let priceHtml = '';
      if (type === 'product' && item.price) {
        priceHtml = `<span class="search-result__price">${formatMoney(item.price)}</span>`;
      }

      li.innerHTML = `
        ${imageHtml}
        <div class="search-result__text">
          <div class="search-result__title">${item.title}</div>
          <div class="search-result__type">${type}</div>
        </div>
        ${priceHtml}
      `;

      li.classList.add('search-result');

      li.addEventListener('click', function () {
        window.location.href = item.url;
      });

      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') window.location.href = item.url;
      });

      list.appendChild(li);
    });
  }

  function setActive(index) {
    const items = list.querySelectorAll('.search-result');
    items.forEach(function (el) {
      el.setAttribute('aria-selected', 'false');
      el.classList.remove('is-active');
    });
    activeIndex = index;
    if (index >= 0 && index < items.length) {
      items[index].setAttribute('aria-selected', 'true');
      items[index].classList.add('is-active');
      items[index].focus();
    }
  }

  input.addEventListener('keydown', function (e) {
    const items = list.querySelectorAll('.search-result');
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(Math.min(activeIndex + 1, items.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (activeIndex <= 0) { input.focus(); activeIndex = -1; }
      else setActive(activeIndex - 1);
    } else if (e.key === 'Enter') {
      if (activeIndex >= 0 && results[activeIndex]) {
        window.location.href = results[activeIndex];
      } else {
        window.location.href = '/search?q=' + encodeURIComponent(input.value) + '&type=product';
      }
    }
  });

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    const query = input.value.trim();
    if (query.length < 2) {
      list.innerHTML = '';
      results = [];
      return;
    }
    debounceTimer = setTimeout(function () {
      fetch(
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product,collection,page&resources[limit]=6'
      )
        .then(function (r) { return r.json(); })
        .then(renderResults)
        .catch(function () {
          list.innerHTML = '<li class="search-results__empty">Something went wrong. Try again.</li>';
        });
    }, 300);
  });
})();